










































































































import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import Team, { distance, timeSpent, timeConvert } from "@/domain/team";
import Player from "@/domain/player";
// import TimeSpent from "@/components/results/results-time-spent.vue";

@Component({
  components: {
    // TimeSpent,
  },
  filters: { distance, timeSpent, timeConvert }
})
export default class Standings extends Vue {
  pageStart = 0;
  pageStop = 0;
  search = "";

  totalScoreSum = 0;
  totalAnswersSum = 0;
  correctAnswersSum = 0;
  incorrectAnswersSum = 0;
  hintsSum = 0;
  odometerSum = 0;
  timeSum = 0;

  get headers() {
    return [
      { text: "#", sortable: false },
      { text: "Team", value: "name" },
      { text: "Score", value: "totalScore", align: "end" },
      { text: "Answers", value: "totalAnswers", align: "end" },
      { text: "Correct", value: "correctAnswers", align: "end" },
      { text: "Incorrect", value: "incorrectAnswers", align: "end" },
      { text: "Hints", value: "hints", align: "end" },
      {
        text: vxm.results.game.units === "metric" ? "Distance (km)" : "Distance (mi)",
        value: "odometer",
        align: "end"
      },
      { text: "Started", value: "startTime", align: "end" },
      { text: "Playtime", value: "time", align: "end" }
    ];
  }

  get fluid() {
    return vxm.app.fluid;
  }

  get publicResults() {
    return vxm.results.game.publicResults.includes("statistics") || vxm.results.isInstructor;
  }

  get teams() {
    if (!this.game.multiplePlayersPerTeam) {
      return vxm.results.teams;
    }

    return vxm.results.teams.map(team => {
      return { ...team, members: vxm.results.players.filter(player => player.teamId === team.id).map(player => player.name) };
    });
  }

  get user() {
    return vxm.auth.user;
  }

  get isInstructor() {
    return vxm.results.isInstructor;
  }

  get game() {
    return vxm.results.game;
  }

  onPagination(event: { pageStart: number; pageStop: number }) {
    this.pageStart = event.pageStart;
    this.pageStop = event.pageStop;
  }

  async downloadCsv() {
    await vxm.results.downloadStandings();
  }

  get downloadingCsv() {
    return vxm.results.standingsDownloading;
  }

  updateSums(teamsOnPage: Team[]) {
    this.totalScoreSum = teamsOnPage.reduce((sum, team) => sum + team.totalScore, 0);
    this.totalAnswersSum = teamsOnPage.reduce((sum, team) => sum + team.totalAnswers, 0);
    this.correctAnswersSum = teamsOnPage.reduce((sum, team) => sum + team.correctAnswers, 0);
    this.incorrectAnswersSum = teamsOnPage.reduce((sum, team) => sum + team.incorrectAnswers, 0);
    this.hintsSum = teamsOnPage.reduce((sum, team) => sum + team.hints, 0);
    this.odometerSum = teamsOnPage.reduce((sum, team) => sum + team.odometer, 0);
    this.timeSum = teamsOnPage.reduce((sum, team) => sum + (team.time ?? 0), 0);
  }
}
